export const reviewContent = {
    fr: {
        title: 'Ce que nos clients en pensent',
        ratingLine: '4,5 sur 5 — plus de 1204 avis',
        reviews: [
            { text: 'Très bon IPTV et sav au top.', name: 'Julien Moreau', location: 'Lyon' },
            { text: 'Service exceptionnel, qualité parfaite.', name: 'Marie Dubois', location: 'Paris' },
            { text: "Meilleur IPTV que j'ai testé.", name: 'Thomas Martin', location: 'Marseille' },
            { text: 'Excellent service client et qualité premium.', name: 'Sophie Bernard', location: 'Bordeaux' },
            { text: 'IPTV de qualité, je recommande vivement.', name: 'Pierre Durand', location: 'Toulouse' },
            { text: 'Service impeccable, très satisfait.', name: 'Isabelle Moreau', location: 'Nantes' },
            { text: "Le meilleur choix pour l'IPTV premium.", name: 'Marc Leroy', location: 'Strasbourg' },
        ],
    },
    es: {
        title: 'Lo que opinan nuestros clientes',
        ratingLine: '4,5 sobre 5 — más de 1204 opiniones',
        reviews: [
            { text: 'Muy buen IPTV y una atención al cliente excelente.', name: 'Javier García', location: 'Madrid' },
            { text: 'Servicio excepcional, calidad perfecta.', name: 'María López', location: 'Barcelona' },
            { text: 'El mejor IPTV que he probado.', name: 'Alejandro Martínez', location: 'Valencia' },
            { text: 'Excelente atención al cliente y calidad premium.', name: 'Carmen Sánchez', location: 'Sevilla' },
            { text: 'IPTV de calidad, lo recomiendo totalmente.', name: 'Pablo Fernández', location: 'Bilbao' },
            { text: 'Servicio impecable, muy satisfecho.', name: 'Lucía Romero', location: 'Zaragoza' },
            { text: 'La mejor opción de IPTV premium.', name: 'Diego Torres', location: 'Málaga' },
        ],
    },
};
